<div class="nha-snackbar" nhaTest="nha-snack-bar">
  <span matSnackBarLabel>
    @if (!data.isHtml) {
      {{ data.message }}
    }
    @if (data.isHtml) {
      <div [innerHTML]="data.message"></div>
    }
  </span>

  @if (hasAction) {
    <div matSnackBarActions class="nha-snackbar-action">
      <button mat-button matSnackBarAction (click)="action()">{{ data.action }}</button>
    </div>
  }
</div>
